import { render, staticRenderFns } from "./ProductCardMainFields.vue?vue&type=template&id=74986ac0&"
import script from "./ProductCardMainFields.vue?vue&type=script&lang=js&"
export * from "./ProductCardMainFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports